import timezone from '@/common/timezone';
import {DateTimeFormats} from '@/common/datetime-formats';
import utils from '../utils';

/**
 * Renders a date row for display.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function dateColumn({cachedColumn, rowData, createElement}) {
    const [value] = utils.getCellValues({cachedColumn, rowData});
    let children;
    if (value) {
        children = timezone.readUTC(value).format(DateTimeFormats.date);
    } else {
        children = [utils.getEmptyCellElement(createElement)];
    }
    return [
        'div',
        {
            attrs: {title: `Time zone: ${timezone.tz()}`},
        },
        children,
    ];
}
